import type { Field, JsonField, TextField } from '@/modules/Project/Fields/types'
import type { Property } from '@/modules/Project/Properties/types'
import type { Entity } from '@/modules/Project/types'
import { invariant } from '@/shared/utils/typeAssertions'

export type HubFields = Record<Property['name'], Field> & {
  index: JsonField
  hubSummary: TextField
}

export function getHubFields(props: { properties: Property[]; entity: Entity }): HubFields {
  const { properties, entity } = props

  let index: JsonField | undefined
  let hubSummary: TextField | undefined
  const otherFields: Record<Property['name'], Field> = {}

  for (const property of properties) {
    const field = entity.fields.get(property.id)

    switch (property.name) {
      case 'index':
        invariant(field && field.type === 'json')
        index = field
        break
      case 'hub_summary':
        invariant(field && field.type === 'text')
        hubSummary = field
        break
      default:
        if (field) {
          otherFields[property.name] = field
        }
    }
  }

  invariant(index)
  invariant(hubSummary)

  return { index, hubSummary, ...otherFields }
}
